import { CreateCommentResponse, CommentMedia } from './types';
import { CommonRequestOptions, makeRequest } from '../makeRequest';

export async function createComment(
   context: string,
   contextid: number,
   text: string,
   parentid?: number,
   media?: CommentMedia[],
   common: CommonRequestOptions = {}
): Promise<CreateCommentResponse> {
   return makeRequest('post', `comments/${context}/${contextid}`, {
      ...common,
      body: {
         text: text,
         parentid: parentid,
         media: media,
      },
   });
}
